import React from 'react'
import { connect } from 'react-redux'
import { withTranslation, WithTranslation } from 'react-i18next'
import moment from 'moment-mini'
import './header.less'
import cargo from '../../assets/cargo.png'
import { AppState } from '../../reducers'

interface Props {
  back?: () => void
  showPageCount?: boolean
  showTimer?: boolean
}

const mapStateToProps = (state: AppState) => ({
  totalPagesCount: state.reservation.totalPagesCount,
  currentPage: state.reservation.currentPage,
})

type StateProps = ReturnType<typeof mapStateToProps>

class Header extends React.PureComponent<Props & StateProps & WithTranslation> {
  private interval: any
  state = {
    time: new Date(),
  }
  componentDidMount() {
    this.interval = setInterval(() => {
      this.setState({ time: new Date() })
    }, 1000)
  }
  componentWillUnmount() {
    this.interval && clearInterval(this.interval)
  }
  render() {
    const { time } = this.state
    const { t, showTimer, showPageCount, back, currentPage, totalPagesCount } = this.props

    return (
      <div className="header">
        <img className="logo" src={cargo} alt="cargo" />
        <div className="header-space" />
        {showTimer && <div className="date">{moment(time).format('DD.MM.YYYY')}</div>}
        {showTimer && <div className="date">{moment(time).format('HH:mm')}</div>}
        {showPageCount && <div className="bold-label">{currentPage}</div>}
        {showPageCount && <div className="label">/ {totalPagesCount}</div>}
        {back && (
          <button className="back-button" onClick={back}>
            <div className="text-button">{'← ' + t('back')}</div>
          </button>
        )}
      </div>
    )
  }
}

export default connect(mapStateToProps)(withTranslation()(Header))
